import React, { memo } from "react";

import "./analytics.css";

function formatStopPct(n) {
	if (n == null || Number.isNaN(n)) return "0%";
	const rounded = Math.round(n * 10) / 10;
	return `${Number.isInteger(rounded) ? rounded : rounded.toFixed(1)}%`;
}

/**
 * Envolve nós do builder na vista analytics com badge vermelho (% que “pararam” neste nó).
 */
export function withAnalyticsStopBadge(Wrapped) {
	const C = memo((props) => {
		const loaded = props.data?.analyticsLoaded === true;
		const pct = props.data?.analyticsStoppedPct ?? 0;
		const stopped = props.data?.analyticsStoppedCount ?? 0;
		const reached = props.data?.analyticsReachedCount ?? 0;
		const total = props.data?.analyticsTotalContacts ?? 0;

		const ariaLabel = loaded
			? `${formatStopPct(pct)} pararam neste bloco. Último passo registado para ${stopped} de ${reached} conversas que chegaram aqui. Total de ${total} conversas criadas no filtro de datas.`
			: undefined;

		return (
			<div className="analytics-node-wrap">
				<Wrapped {...props} />
				{loaded && stopped > 0 ? (
					<div
						className="analytics-node-stop-badge nodrag nopan"
						aria-label={ariaLabel}
					>
						{formatStopPct(pct)}
						<div className="analytics-node-stop-tooltip" role="tooltip">
							<strong>{formatStopPct(pct)}</strong> das conversas que chegaram a este bloco
							tiveram aqui o <strong>último passo registado</strong> no período.
							<span className="analytics-node-stop-tooltip__meta">
								{stopped}{" "}
								{stopped === 1 ? "conversa parou" : "conversas pararam"} neste ponto ·{" "}
								{reached}{" "}
								{reached === 1 ? "chegou" : "chegaram"} ao bloco · {total} criadas no filtro de datas
							</span>
						</div>
					</div>
				) : null}
			</div>
		);
	});
	C.displayName = `AnalyticsStop(${
		Wrapped.displayName || Wrapped.name || "Node"
	})`;
	return C;
}
